import type { JobDetails } from '@/types';

export function sortJobsByMostRecent(jobDetails: JobDetails[]) {
    if (!jobDetails) {
        return jobDetails;
    }
    const data: JobDetails[] = [...jobDetails];
    data?.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

    return data;
}
